import React, { useState } from 'react';

const Fall = (props) => {
  const M_TO_PX = props.M_TO_PX;
  const totalWidth = (props.xMax - props.xMin) * M_TO_PX;
  const totalHeight = (props.yMax - props.yMin) * M_TO_PX;
  const xPosM = props.fall.x_cm / 100;
  const yPosM = props.fall.y_cm / 100;
  const isCeiling = props.isCeiling;
  const yShift = props.yShift;
  const yShiftMargin = props.yShiftMargin;
  const xShift = props.xShift
  const cx = isCeiling ? parseFloat(xPosM * M_TO_PX) + (totalWidth / 2) - props.marginLeft
                       : parseFloat((-xPosM + xShift) * M_TO_PX) + (totalWidth / 2) - props.marginLeft;
  const cy = isCeiling ? -parseFloat(((yPosM + 2*yShiftMargin - yShift) * M_TO_PX) - props.marginTop) + (totalHeight / 2)
                       : parseFloat(yPosM * M_TO_PX);

  return (
    <>
      <svg
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        width={totalWidth}
        height={totalHeight}
        viewBox={`0 0 ${totalWidth} ${totalHeight}`}
      >
        <circle
          cx={cx}
          cy={cy}
          r={5}
          fill={(props.fall.type === 5) ? "red" : "orange"}
          style={{ pointerEvents: 'all', cursor: 'pointer' }}
        />
      </svg>
    </>
  );
};

export default Fall;
